angular.module('Firebase', [])
    .factory('Firebase', [function () {
        return {
            authenticate: function (firebaseUrl, firebaseApiKey, firebaseToken) {
                if (firebaseUrl == "" || typeof firebaseUrl === "undefined" || firebaseApiKey == "" || typeof firebaseApiKey === "undefined" || firebaseToken == "" || typeof firebaseToken === "undefined") return;
                if (!firebase.apps.length) {
                    firebase.initializeApp({
                        apiKey: firebaseApiKey,
                        databaseURL: firebaseUrl
                    });
                }
            }
        }
    }]);

angular.module('leaguestatFirebaseService', ['Firebase'])
    .factory('leaguestatFirebaseService',
        ['Firebase', '$rootScope', function (Firebase, $rootScope) {

            var databaseRef;

            // Collection of callbacks and data for game clocks
            var gameClockCallbacks = {
                /*
                // MODEL FORMAT:
        
                // Unique game identifier form: clientCode-langId-gameId
                lhjmq-1-1234: {
                    publishedClockData: {...},
                    runningClockData: {...},
                    listenerCallbacks: []
                },
                ...
        
                */
            };

            // Collection of callbacks and data for game goal summary
            var gameGoalSummaryCallbacks = {
                /*
                // MODEL FORMAT:
        
                // Unique game identifier form: clientCode-langId-gameId
                lhjmq-1-1234: {
                    goalSummaryData: {...},
                    listenerCallbacks: []
                },
                ...
        
                */
            };

            // Collection of callbacks and data for game shot summary
            var gamePenaltySummaryCallbacks = {
                /*
                // MODEL FORMAT:
        
                // Unique game identifier form: clientCode-langId-gameId
                lhjmq-1-1234: {
                    penaltySummaryData: {...},
                    listenerCallbacks: []
                },
                ...
        
                */
            };

            // Collection of callbacks and data for game shot summary
            var gameShotSummaryCallbacks = {
                /*
                // MODEL FORMAT:
        
                // Unique game identifier form: clientCode-langId-gameId
                lhjmq-1-1234: {
                    shotSummaryData: {...},
                    listenerCallbacks: []
                },
                ...
        
                */
            };

            // Collection of callbacks and data for game penalties
            var gamePenaltiesCallbacks = {
                /*
                // MODEL FORMAT:
        
                // Unique game identifier form: clientCode-langId-gameId
                lhjmq-1-1234: {
                    penaltiesData: {...},
                    listenerCallbacks: []
                },
                ...
        
                */
            };

            // Collection of callbacks and data for game scoring
            var gameScoringCallbacks = {
                /*
                // MODEL FORMAT:
        
                // Unique game identifier form: clientCode-langId-gameId
                lhjmq-1-1234: {
                    scoringData: {...},
                    listenerCallbacks: []
                },
                ...
        
                */
            };

            // Collection of callbacks and data for game scoring
            var gameMVPsCallbacks = {
                /*
                // MODEL FORMAT:
        
                // Unique game identifier form: clientCode-langId-gameId
                lhjmq-1-1234: {
                    mvpsData: {...},
                    listenerCallbacks: []
                },
                ...
        
                */
            };

            var addToGameClockCallbacks = function (clientCode, gameId, langId, listenerCallback) {
                var gameUid = createGameUid(clientCode, gameId, langId);

                if (!gameClockCallbacks[gameUid]) {
                    gameClockCallbacks[gameUid] = {
                        listenerCallbacks: []
                    }
                }

                gameClockCallbacks[gameUid].listenerCallbacks.push(listenerCallback);
            };


            var addToGameGoalSummaryCallbacks = function (clientCode, gameId, langId, listenerCallback) {
                var gameUid = createGameUid(clientCode, gameId, langId);

                if (!gameGoalSummaryCallbacks[gameUid]) {
                    gameGoalSummaryCallbacks[gameUid] = {
                        listenerCallbacks: []
                    }
                }

                gameGoalSummaryCallbacks[gameUid].listenerCallbacks.push(listenerCallback);
            };

            var addToGamePenaltySummaryCallbacks = function (clientCode, gameId, langId, listenerCallback) {
                var gameUid = createGameUid(clientCode, gameId, langId);

                if (!gamePenaltySummaryCallbacks[gameUid]) {
                    gamePenaltySummaryCallbacks[gameUid] = {
                        listenerCallbacks: []
                    }
                }

                gamePenaltySummaryCallbacks[gameUid].listenerCallbacks.push(listenerCallback);
            };

            var addToGameShotSummaryCallbacks = function (clientCode, gameId, langId, listenerCallback) {
                var gameUid = createGameUid(clientCode, gameId, langId);

                if (!gameShotSummaryCallbacks[gameUid]) {
                    gameShotSummaryCallbacks[gameUid] = {
                        listenerCallbacks: []
                    }
                }

                gameShotSummaryCallbacks[gameUid].listenerCallbacks.push(listenerCallback);
            };

            var addToGamePenaltiesCallbacks = function (clientCode, gameId, langId, listenerCallback) {
                var gameUid = createGameUid(clientCode, gameId, langId);

                if (!gamePenaltiesCallbacks[gameUid]) {
                    gamePenaltiesCallbacks[gameUid] = {
                        listenerCallbacks: []
                    }
                }

                gamePenaltiesCallbacks[gameUid].listenerCallbacks.push(listenerCallback);
            };

            var addToGameScoringCallbacks = function (clientCode, gameId, langId, listenerCallback) {
                var gameUid = createGameUid(clientCode, gameId, langId);

                if (!gameScoringCallbacks[gameUid]) {
                    gameScoringCallbacks[gameUid] = {
                        listenerCallbacks: []
                    }
                }

                gameScoringCallbacks[gameUid].listenerCallbacks.push(listenerCallback);
            };

            var addToGameMVPsCallbacks = function (clientCode, gameId, langId, listenerCallback) {
                var gameUid = createGameUid(clientCode, gameId, langId);

                if (!gameMVPsCallbacks[gameUid]) {
                    gameMVPsCallbacks[gameUid] = {
                        listenerCallbacks: []
                    }
                }

                gameMVPsCallbacks[gameUid].listenerCallbacks.push(listenerCallback);
            };

            var authenticate = function (dbUrl, apiKey, token) {
                Firebase.authenticate(dbUrl, apiKey, token);
                databaseRef = firebase.database().ref();
                return true;
            };

            var combineClocks = function (gamePublishedClock, gameRunningClock) {
                /*
                    Methodology
                    A 'combined' clock is the union of information from both the 'published' clock and 'running' clock.
                    This logically consistent way to combine these two clocks is to:
                        1. If we don't have a 'published' clock => do nothing (we dont have enough information yet)
                        2. If we don't have a 'running' clock => use the 'published' clock's data
                        3. Otherwise, use all the data from the 'published' clock with the minutes and seconds overwritten
                            by the 'running clock'
                */
                if (!gamePublishedClock) {
                    return null; // Case 1 (above)
                }

                var combinedClock = angular.copy(gamePublishedClock);

                if (!gameRunningClock) return combinedClock; // Case 2 (above)

                combinedClock.ClockMinutes = parseInt(gameRunningClock.Clock.Minutes);
                combinedClock.ClockSeconds = parseInt(gameRunningClock.Clock.Seconds);

                return combinedClock;
            };

            var createGameUid = function (clientCode, gameId, langId) {
                if (!clientCode) {
                    console.log("ERROR: svfFb::createGameUid saw an invalid clientCode - ", clientCode);
                    return undefined;
                }
                if (!gameId) {
                    console.log("ERROR: svfFb::createGameUid saw an invalid gameId - ", gameId);
                    return undefined;
                }
                if (!langId) {
                    console.log("ERROR: svfFb::createGameUid saw an invalid langId - ", langId);
                    return undefined;
                }

                return clientCode + '-' + gameId + '-' + langId;
            };

            let getGameIdFromGameUid = function (gameUid) {
                if (!gameUid) {
                    return undefined;
                }

                var splitUid = gameUid.split("-");

                if (splitUid.length !== 3) {
                    console.log("ERROR: svfFb::getGameIdFromGameUid saw an invalid gameUid - ", gameUid);
                    return undefined;
                }

                return splitUid[1];
            }

            var gameClockCallbacksEmpty = function (gameUid) {
                if (!gameUid) {
                    console.log("ERROR: svfFb::gameClockCallbacksEmpty got an invalid gameUid param - ", gameUid);
                }

                if (!gameClockCallbacks[gameUid]) return true;

                if (!gameClockCallbacks[gameUid].listenerCallbacks) return true;

                if (!gameClockCallbacks[gameUid].listenerCallbacks.length) return true;

                return false;
            };

            var gameGoalSummaryCallbacksEmpty = function (gameUid) {
                if (!gameUid) {
                    console.log("ERROR: svfFb::gameGoalSummaryCallbacksEmpty got an invalid gameUid param - ", gameUid);
                }

                if (!gameGoalSummaryCallbacks[gameUid]) return true;

                if (!gameGoalSummaryCallbacks[gameUid].listenerCallbacks) return true;

                if (!gameGoalSummaryCallbacks[gameUid].listenerCallbacks.length) return true;

                return false;
            };

            var gamePenaltySummaryCallbacksEmpty = function (gameUid) {
                if (!gameUid) {
                    console.log("ERROR: svfFb::gamePenaltySummaryCallbacksEmpty got an invalid gameUid param - ", gameUid);
                }

                if (!gamePenaltySummaryCallbacks[gameUid]) return true;

                if (!gamePenaltySummaryCallbacks[gameUid].listenerCallbacks) return true;

                if (!gamePenaltySummaryCallbacks[gameUid].listenerCallbacks.length) return true;

                return false;
            };

            var gameShotSummaryCallbacksEmpty = function (gameUid) {
                if (!gameUid) {
                    console.log("ERROR: svfFb::gameShotSummaryCallbacksEmpty got an invalid gameUid param - ", gameUid);
                }

                if (!gameShotSummaryCallbacks[gameUid]) return true;

                if (!gameShotSummaryCallbacks[gameUid].listenerCallbacks) return true;

                if (!gameShotSummaryCallbacks[gameUid].listenerCallbacks.length) return true;

                return false;
            };

            var gamePenaltiesCallbacksEmpty = function (gameUid) {
                if (!gameUid) {
                    console.log("ERROR: svfFb::gamePenaltiesCallbacksEmpty got an invalid gameUid param - ", gameUid);
                }

                if (!gamePenaltiesCallbacks[gameUid]) return true;

                if (!gamePenaltiesCallbacks[gameUid].listenerCallbacks) return true;

                if (!gamePenaltiesCallbacks[gameUid].listenerCallbacks.length) return true;

                return false;
            };

            var gameScoringCallbacksEmpty = function (gameUid) {
                if (!gameUid) {
                    console.log("ERROR: svfFb::gameScoringCallbacksEmpty got an invalid gameUid param - ", gameUid);
                }

                if (!gameScoringCallbacks[gameUid]) return true;

                if (!gameScoringCallbacks[gameUid].listenerCallbacks) return true;

                if (!gameScoringCallbacks[gameUid].listenerCallbacks.length) return true;

                return false;
            };

            var gameMVPsCallbacksEmpty = function (gameUid) {
                if (!gameUid) {
                    console.log("ERROR: svfFb::gameMVPsCallbacksEmpty got an invalid gameUid param - ", gameUid);
                }

                if (!gameMVPsCallbacks[gameUid]) return true;

                if (!gameMVPsCallbacks[gameUid].listenerCallbacks) return true;

                if (!gameMVPsCallbacks[gameUid].listenerCallbacks.length) return true;

                return false;
            };

            var handleGamePenaltiesUpdate = function (snapshot) {
                // Get clientCode, langId and gameId
                var snapshotUrl = snapshot.ref.toString();
                var splitUrl = snapshotUrl.split("/");

                var gameId = parseInt(splitUrl[splitUrl.length - 1]);
                var langId = parseInt(splitUrl[splitUrl.length - 3]);
                var clientCode = splitUrl[splitUrl.length - 5];

                var gameUid = createGameUid(clientCode, gameId, langId);

                gamePenaltiesCallbacks[gameUid].penaltiesData = snapshot.val();

                notifyGamePenaltiesListeners(gameUid);
            };

            var handleGameGoalSummaryUpdate = function (snapshot) {
                // Get clientCode, langId and gameId
                var snapshotUrl = snapshot.ref.toString();
                var splitUrl = snapshotUrl.split("/");

                var gameId = parseInt(splitUrl[splitUrl.length - 1]);
                var langId = parseInt(splitUrl[splitUrl.length - 3]);
                var clientCode = splitUrl[splitUrl.length - 5];

                var gameUid = createGameUid(clientCode, gameId, langId);

                gameGoalSummaryCallbacks[gameUid].goalSummaryData = snapshot.val();

                notifyGameGoalSummaryListeners(gameUid);
            };

            var handleGamePenaltySummaryUpdate = function (snapshot) {
                // Get clientCode, langId and gameId
                var snapshotUrl = snapshot.ref.toString();
                var splitUrl = snapshotUrl.split("/");

                var gameId = parseInt(splitUrl[splitUrl.length - 1]);
                var langId = parseInt(splitUrl[splitUrl.length - 3]);
                var clientCode = splitUrl[splitUrl.length - 5];

                var gameUid = createGameUid(clientCode, gameId, langId);

                gamePenaltySummaryCallbacks[gameUid].penaltySummaryData = snapshot.val();

                notifyGamePenaltySummaryListeners(gameUid);
            };

            var handleGameShotSummaryUpdate = function (snapshot) {
                // Get clientCode, langId and gameId
                var snapshotUrl = snapshot.ref.toString();
                var splitUrl = snapshotUrl.split("/");

                var gameId = parseInt(splitUrl[splitUrl.length - 1]);
                var langId = parseInt(splitUrl[splitUrl.length - 3]);
                var clientCode = splitUrl[splitUrl.length - 5];

                var gameUid = createGameUid(clientCode, gameId, langId);

                gameShotSummaryCallbacks[gameUid].shotSummaryData = snapshot.val();

                notifyGameShotSummaryListeners(gameUid);
            };

            var handlePublishedClockUpdate = function (snapshot) {
                // Get clientCode, langId and gameId
                var snapshotUrl = snapshot.ref.toString();
                var splitUrl = snapshotUrl.split("/");

                var gameId = parseInt(splitUrl[splitUrl.length - 1]);
                var langId = parseInt(splitUrl[splitUrl.length - 3]);
                var clientCode = splitUrl[splitUrl.length - 5];

                var gameUid = createGameUid(clientCode, gameId, langId);

                gameClockCallbacks[gameUid].publishedClockData = snapshot.val();

                notifyGameClockListeners(gameUid);
            };

            var handleRunningClockUpdate = function (snapshot) {
                // Get clientCode, langId and gameId
                var snapshotUrl = snapshot.ref.toString();
                var splitUrl = snapshotUrl.split("/");

                var gameId = parseInt(splitUrl[splitUrl.length - 1]);
                var clientCode = splitUrl[splitUrl.length - 4];

                var enGameUid = createGameUid(clientCode, gameId, 1);
                var frGameUid = createGameUid(clientCode, gameId, 2);

                if (gameClockCallbacks[enGameUid]) { // Update english clocks
                    gameClockCallbacks[enGameUid].runningClockData = snapshot.val();
                    notifyGameClockListeners(enGameUid);
                }

                if (gameClockCallbacks[frGameUid]) { // Update french clocks
                    gameClockCallbacks[frGameUid].runningClockData = snapshot.val();
                    notifyGameClockListeners(frGameUid);
                }
            };

            var handleGameScoringUpdate = function (snapshot) {
                // Get clientCode, langId and gameId
                var snapshotUrl = snapshot.ref.toString();
                var splitUrl = snapshotUrl.split("/");

                var gameId = parseInt(splitUrl[8]);
                var langId = parseInt(splitUrl[6]);
                var clientCode = splitUrl[4];

                var gameUid = createGameUid(clientCode, gameId, langId);

                gameScoringCallbacks[gameUid].scoringData = snapshot.val();

                notifyGameScoringListeners(gameUid);
            };

            var handleGameMVPsUpdate = function (snapshot) {
                // Get clientCode, langId and gameId
                var snapshotUrl = snapshot.ref.toString();
                var splitUrl = snapshotUrl.split("/");

                var gameId = parseInt(splitUrl[8]);
                var langId = parseInt(splitUrl[6]);
                var clientCode = splitUrl[4];

                var gameUid = createGameUid(clientCode, gameId, langId);

                gameMVPsCallbacks[gameUid].mvpsData = snapshot.val();

                notifyGameMVPsListeners(gameUid);
            };

            var notifyGameClockListeners = function (gameUid) {
                if (!gameClockCallbacksEmpty(gameUid)) {
                    angular.forEach(gameClockCallbacks[gameUid].listenerCallbacks, function (listenerCallback) {
                        listenerCallback(
                            combineClocks(
                                gameClockCallbacks[gameUid].publishedClockData,
                                gameClockCallbacks[gameUid].runningClockData
                            )
                        );
                    });
                }
            };

            var notifyGameGoalSummaryListeners = function (gameUid) {
                if (!gameGoalSummaryCallbacksEmpty(gameUid)) {
                    angular.forEach(gameGoalSummaryCallbacks[gameUid].listenerCallbacks, function (listenerCallback) {
                        let lsGameId = getGameIdFromGameUid(gameUid);

                        if (gameGoalSummaryCallbacks[gameUid].goalSummaryData) {
                            gameGoalSummaryCallbacks[gameUid].goalSummaryData.GameId = parseInt(lsGameId);
                        }
                        listenerCallback(gameGoalSummaryCallbacks[gameUid].goalSummaryData);
                    });
                }
            };

            var notifyGamePenaltySummaryListeners = function (gameUid) {
                if (!gamePenaltySummaryCallbacksEmpty(gameUid)) {
                    angular.forEach(gamePenaltySummaryCallbacks[gameUid].listenerCallbacks, function (listenerCallback) {
                        listenerCallback(gamePenaltySummaryCallbacks[gameUid].penaltySummaryData);
                    });
                }
            };

            var notifyGameShotSummaryListeners = function (gameUid) {
                if (!gameShotSummaryCallbacksEmpty(gameUid)) {
                    angular.forEach(gameShotSummaryCallbacks[gameUid].listenerCallbacks, function (listenerCallback) {
                        listenerCallback(gameShotSummaryCallbacks[gameUid].shotSummaryData);
                    });
                }
            };

            var notifyGamePenaltiesListeners = function (gameUid) {
                if (!gamePenaltiesCallbacksEmpty(gameUid)) {
                    angular.forEach(gamePenaltiesCallbacks[gameUid].listenerCallbacks, function (listenerCallback) {
                        listenerCallback(gamePenaltiesCallbacks[gameUid].penaltiesData);
                    });
                }
            };

            var notifyGameScoringListeners = function (gameUid) {
                if (!gameScoringCallbacksEmpty(gameUid)) {
                    angular.forEach(gameScoringCallbacks[gameUid].listenerCallbacks, function (listenerCallback) {
                        listenerCallback(gameScoringCallbacks[gameUid].scoringData);
                    });
                }
            };

            var notifyGameMVPsListeners = function (gameUid) {
                if (!gameMVPsCallbacksEmpty(gameUid)) {
                    angular.forEach(gameMVPsCallbacks[gameUid].listenerCallbacks, function (listenerCallback) {
                        listenerCallback(gameMVPsCallbacks[gameUid].scoringData);
                    });
                }
            };

            var removeFromGameClockCallbacks = function (clientCode, gameId, langId, listenerCallback) {
                var gameUid = createGameUid(clientCode, gameId, langId);

                if (!gameClockCallbacks[gameUid]) {
                    console.log("ERROR: removeFromGameClockCallbacks called on callback that is not in our collection of callbacks (place 1)", gameClockCallbacks, gameUid);
                    return;
                }

                if (!gameClockCallbacks[gameUid].listenerCallbacks) {
                    console.log("ERROR: removeFromGameClockCallbacks called on callback that is not in our collection of callbacks (place 2)", gameClockCallbacks, gameUid);
                    return;
                }

                if (!gameClockCallbacks[gameUid].listenerCallbacks.length) {
                    console.log("ERROR: removeFromGameClockCallbacks called on callback that is not in our collection of callbacks (place 3)", gameClockCallbacks, gameUid);
                    return;
                }

                for (var i = 0; i < gameClockCallbacks[gameUid].listenerCallbacks.length; i++) {
                    if (gameClockCallbacks[gameUid].listenerCallbacks[i] == listenerCallback) {
                        gameClockCallbacks[gameUid].listenerCallbacks.splice(i, 1);
                        return;
                    }
                }

                console.log("ERROR: removeFromGameClockCallbacks called on callback that is not in our collection of callbacks (place 4)", gameClockCallbacks, gameUid);
            };

            var removeFromGameGoalSummaryCallbacks = function (clientCode, gameId, langId, listenerCallback) {
                var gameUid = createGameUid(clientCode, gameId, langId);

                if (!gameGoalSummaryCallbacks[gameUid]) {
                    console.log("ERROR: removeFromGameGoalSummaryCallbacks called on callback that is not in our collection of callbacks (place 1)", gameGoalSummaryCallbacks, gameUid);
                    return;
                }

                if (!gameGoalSummaryCallbacks[gameUid].listenerCallbacks) {
                    console.log("ERROR: removeFromGameGoalSummaryCallbacks called on callback that is not in our collection of callbacks (place 2)", gameGoalSummaryCallbacks, gameUid);
                    return;
                }

                if (!gameGoalSummaryCallbacks[gameUid].listenerCallbacks.length) {
                    console.log("ERROR: removeFromGameGoalSummaryCallbacks called on callback that is not in our collection of callbacks (place 3)", gameGoalSummaryCallbacks, gameUid);
                    return;
                }

                for (var i = 0; i < gameGoalSummaryCallbacks[gameUid].listenerCallbacks.length; i++) {
                    if (gameGoalSummaryCallbacks[gameUid].listenerCallbacks[i] == listenerCallback) {
                        gameGoalSummaryCallbacks[gameUid].listenerCallbacks.splice(i, 1);
                        return;
                    }
                }

                console.log("ERROR: removeFromGameGoalSummaryCallbacks called on callback that is not in our collection of callbacks (place 4)", gameGoalSummaryCallbacks, gameUid);
            };

            var removeFromGamePenaltySummaryCallbacks = function (clientCode, gameId, langId, listenerCallback) {
                var gameUid = createGameUid(clientCode, gameId, langId);

                if (!gamePenaltySummaryCallbacks[gameUid]) {
                    console.log("ERROR: removeFromGamePenaltySummaryCallbacks called on callback that is not in our collection of callbacks (place 1)", gamePenaltySummaryCallbacks, gameUid);
                    return;
                }

                if (!gamePenaltySummaryCallbacks[gameUid].listenerCallbacks) {
                    console.log("ERROR: removeFromGamePenaltySummaryCallbacks called on callback that is not in our collection of callbacks (place 2)", gamePenaltySummaryCallbacks, gameUid);
                    return;
                }

                if (!gamePenaltySummaryCallbacks[gameUid].listenerCallbacks.length) {
                    console.log("ERROR: removeFromGamePenaltySummaryCallbacks called on callback that is not in our collection of callbacks (place 3)", gamePenaltySummaryCallbacks, gameUid);
                    return;
                }

                for (var i = 0; i < gamePenaltySummaryCallbacks[gameUid].listenerCallbacks.length; i++) {
                    if (gamePenaltySummaryCallbacks[gameUid].listenerCallbacks[i] == listenerCallback) {
                        gamePenaltySummaryCallbacks[gameUid].listenerCallbacks.splice(i, 1);
                        return;
                    }
                }

                console.log("ERROR: removeFromGamePenaltySummaryCallbacks called on callback that is not in our collection of callbacks (place 4)", gamePenaltySummaryCallbacks, gameUid);
            };

            var removeFromGameShotSummaryCallbacks = function (clientCode, gameId, langId, listenerCallback) {
                var gameUid = createGameUid(clientCode, gameId, langId);

                if (!gameShotSummaryCallbacks[gameUid]) {
                    console.log("ERROR: removeFromGameShotSummaryCallbacks called on callback that is not in our collection of callbacks (place 1)", gameShotSummaryCallbacks, gameUid);
                    return;
                }

                if (!gameShotSummaryCallbacks[gameUid].listenerCallbacks) {
                    console.log("ERROR: removeFromGameShotSummaryCallbacks called on callback that is not in our collection of callbacks (place 2)", gameShotSummaryCallbacks, gameUid);
                    return;
                }

                if (!gameShotSummaryCallbacks[gameUid].listenerCallbacks.length) {
                    console.log("ERROR: removeFromGameShotSummaryCallbacks called on callback that is not in our collection of callbacks (place 3)", gameShotSummaryCallbacks, gameUid);
                    return;
                }

                for (var i = 0; i < gameShotSummaryCallbacks[gameUid].listenerCallbacks.length; i++) {
                    if (gameShotSummaryCallbacks[gameUid].listenerCallbacks[i] == listenerCallback) {
                        gameShotSummaryCallbacks[gameUid].listenerCallbacks.splice(i, 1);
                        return;
                    }
                }

                console.log("ERROR: removeFromGameShotSummaryCallbacks called on callback that is not in our collection of callbacks (place 4)", gameShotSummaryCallbacks, gameUid);
            };

            var removeFromGameScoringCallbacks = function (clientCode, gameId, langId, listenerCallback) {
                var gameUid = createGameUid(clientCode, gameId, langId);

                if (!gameScoringCallbacks[gameUid]) {
                    console.log("ERROR: removeFromgameScoringCallbacks called on callback that is not in our collection of callbacks (place 1)", gameScoringCallbacks, gameUid);
                    return;
                }

                if (!gameScoringCallbacks[gameUid].listenerCallbacks) {
                    console.log("ERROR: removeFromgameScoringCallbacks called on callback that is not in our collection of callbacks (place 2)", gameScoringCallbacks, gameUid);
                    return;
                }

                if (!gameScoringCallbacks[gameUid].listenerCallbacks.length) {
                    console.log("ERROR: removeFromgameScoringCallbacks called on callback that is not in our collection of callbacks (place 3)", gameScoringCallbacks, gameUid);
                    return;
                }

                for (var i = 0; i < gameScoringCallbacks[gameUid].listenerCallbacks.length; i++) {
                    if (gameScoringCallbacks[gameUid].listenerCallbacks[i] == listenerCallback) {
                        gameScoringCallbacks[gameUid].listenerCallbacks.splice(i, 1);
                        return;
                    }
                }

                console.log("ERROR: removeFromGameScoringCallbacks called on callback that is not in our collection of callbacks (place 4)", gameScoringCallbacks, gameUid);
            };

            var removeFromGamePenaltiesCallbacks = function (clientCode, gameId, langId, listenerCallback) {
                var gameUid = createGameUid(clientCode, gameId, langId);

                if (!gamePenaltiesCallbacks[gameUid]) {
                    console.log("ERROR: removeFromGamePenaltiesCallbacks called on callback that is not in our collection of callbacks (place 1)", gamePenaltiesCallbacks, gameUid);
                    return;
                }

                if (!gamePenaltiesCallbacks[gameUid].listenerCallbacks) {
                    console.log("ERROR: removeFromGamePenaltiesCallbacks called on callback that is not in our collection of callbacks (place 2)", gamePenaltiesCallbacks, gameUid);
                    return;
                }

                if (!gamePenaltiesCallbacks[gameUid].listenerCallbacks.length) {
                    console.log("ERROR: removeFromGamePenaltiesCallbacks called on callback that is not in our collection of callbacks (place 3)", gamePenaltiesCallbacks, gameUid);
                    return;
                }

                for (var i = 0; i < gamePenaltiesCallbacks[gameUid].listenerCallbacks.length; i++) {
                    if (gamePenaltiesCallbacks[gameUid].listenerCallbacks[i] == listenerCallback) {
                        gamePenaltiesCallbacks[gameUid].listenerCallbacks.splice(i, 1);
                        return;
                    }
                }

                console.log("ERROR: removeFromGameShotSummaryCallbacks called on callback that is not in our collection of callbacks (place 4)", gamePenaltiesCallbacks, gameUid);
            };

            var removeFromGameMVPsCallbacks = function (clientCode, gameId, langId, listenerCallback) {
                var gameUid = createGameUid(clientCode, gameId, langId);

                if (!gameMVPsCallbacks[gameUid]) {
                    console.log("ERROR: removeFromgameMVPsCallbacks called on callback that is not in our collection of callbacks (place 1)", gameMVPsCallbacks, gameUid);
                    return;
                }

                if (!gameMVPsCallbacks[gameUid].listenerCallbacks) {
                    console.log("ERROR: removeFromgameMVPsCallbacks called on callback that is not in our collection of callbacks (place 2)", gameMVPsCallbacks, gameUid);
                    return;
                }

                if (!gameMVPsCallbacks[gameUid].listenerCallbacks.length) {
                    console.log("ERROR: removeFromgameMVPsCallbacks called on callback that is not in our collection of callbacks (place 3)", gameMVPsCallbacks, gameUid);
                    return;
                }

                for (var i = 0; i < gameMVPsCallbacks[gameUid].listenerCallbacks.length; i++) {
                    if (gameMVPsCallbacks[gameUid].listenerCallbacks[i] == listenerCallback) {
                        gameMVPsCallbacks[gameUid].listenerCallbacks.splice(i, 1);
                        return;
                    }
                }

                console.log("ERROR: removeFromGameShotSummaryCallbacks called on callback that is not in our collection of callbacks (place 4)", gameMVPsCallbacks, gameUid);
            };

            // TODO: Subscribe to the game clocks by date (used in the daily schedule)
            var subscribeToDateClock = function (clientCode, subscribeDate, langId) {
                if (!clientCode) console.log("ERROR: svfFb::openDateClockSubscription got a bad clientCode param - ", clientCode);
                if (!subscribeDate) console.log("ERROR: svfFb::openDateClockSubscription got a bad subscribeDate param - ", subscribeDate);
                if (!langId || langId > 2) console.log("ERROR: svfFb::openDateClockSubscription got a bad langId param - ", langId);

                // ...

            };

            var subscribeToGameClock = function (clientCode, gameId, langId, listenerCallback) {
                if (!gameId) console.log("ERROR: svfFb::subscribeToGameClock saw an invalid gameId ", gameId);
                if (!langId || langId > 1) console.log("ERROR: svfFb::subscribeToGameClock saw an invalid langId param ", langId);
                if (!listenerCallback) console.log("ERROR: svfFb::subscribeToGameClock saw an invalid listenerCallback param ", listenerCallback);

                var subscribeToFb = false;

                if (gameClockCallbacksEmpty(createGameUid(clientCode, gameId, langId))) { // Determine if this is the first subscription.
                    subscribeToFb = true;
                }

                addToGameClockCallbacks(clientCode, gameId, langId, listenerCallback);
                if (gameClockCallbacksEmpty(createGameUid(clientCode, gameId, langId))) {
                    console.log("ERROR: svfFb::subscribeToGameClock saw an inconsistency where the callbacks are empty after adding to the callbacks", gameClockCallbacks, clientCode, gameId, langId, listenerCallback);
                }

                if (subscribeToFb) { // Open up the firebase listeners.
                    databaseRef.child("/svf/" + clientCode + "/publishedclock/" + langId + "/games/" + gameId).on('value', handlePublishedClockUpdate);
                    databaseRef.child("/svf/" + clientCode + "/runningclock/games/" + gameId).on('value', handleRunningClockUpdate);
                }

                return;
            };

            var subscribeToGameGoalSummary = function (clientCode, gameId, langId, listenerCallback) {

                if (!gameId) console.log("ERROR: svfFb::subscribeToGameGoalSummary saw an invalid gameId ", gameId);
                if (!langId || langId > 1) console.log("ERROR: svfFb::subscribeToGameGoalSummary saw an invalid langId param ", langId);
                if (!listenerCallback) console.log("ERROR: svfFb::subscribeToGameGoalSummary saw an invalid listenerCallback param ", listenerCallback);

                var subscribeToFb = false;

                if (gameGoalSummaryCallbacksEmpty(createGameUid(clientCode, gameId, langId))) {
                    subscribeToFb = true;
                }

                addToGameGoalSummaryCallbacks(clientCode, gameId, langId, listenerCallback);
                if (gameGoalSummaryCallbacksEmpty(createGameUid(clientCode, gameId, langId))) {
                    console.log("ERROR: svfFb::subscribeToGameGoalSummary saw an inconsistency where the callbacks are empty after adding to it", gameGoalSummaryCallbacks);
                }

                if (subscribeToFb) {
                    databaseRef.child(
                        "/svf/" + clientCode + "/goalssummary/" + langId + "/games/" + gameId
                    ).on('value', handleGameGoalSummaryUpdate);
                }

                return;

            };

            var subscribeToGamePenaltySummary = function (clientCode, gameId, langId, listenerCallback) {

                if (!gameId) console.log("ERROR: svfFb::subscribeToGamePenaltySummary saw an invalid gameId ", gameId);
                if (!langId || langId > 1) console.log("ERROR: svfFb::subscribeToGamePenaltySummary saw an invalid langId param ", langId);
                if (!listenerCallback) console.log("ERROR: svfFb::subscribeToGamePenaltySummary saw an invalid listenerCallback param ", listenerCallback);

                var subscribeToFb = false;

                if (gamePenaltySummaryCallbacksEmpty(createGameUid(clientCode, gameId, langId))) {
                    subscribeToFb = true;
                }

                addToGamePenaltySummaryCallbacks(clientCode, gameId, langId, listenerCallback);
                if (gamePenaltySummaryCallbacksEmpty(createGameUid(clientCode, gameId, langId))) {
                    console.log("ERROR: svfFb::subscribeToGamePenaltySummary saw an inconsistency where the callbacks are empty after adding to it", gamePenaltySummaryCallbacks);
                }

                if (subscribeToFb) {
                    databaseRef.child(
                        "/svf/" + clientCode + "/penaltiessummary/" + langId + "/games/" + gameId
                    ).on('value', handleGamePenaltySummaryUpdate);
                }

                return;

            };

            var subscribeToGameShotSummary = function (clientCode, gameId, langId, listenerCallback) {

                if (!gameId) console.log("ERROR: svfFb::subscribeToGameShotSummary saw an invalid gameId ", gameId);
                if (!langId || langId > 1) console.log("ERROR: svfFb::subscribeToGameShotSummary saw an invalid langId param ", langId);
                if (!listenerCallback) console.log("ERROR: svfFb::subscribeToGameShotSummary saw an invalid listenerCallback param ", listenerCallback);

                var subscribeToFb = false;

                if (gameShotSummaryCallbacksEmpty(createGameUid(clientCode, gameId, langId))) {
                    subscribeToFb = true;
                }

                addToGameShotSummaryCallbacks(clientCode, gameId, langId, listenerCallback);
                if (gameShotSummaryCallbacksEmpty(createGameUid(clientCode, gameId, langId))) {
                    console.log("ERROR: svfFb::subscribeToGameShotSummary saw an inconsistency where the callbacks are empty after adding to it", gameShotSummaryCallbacks);
                }

                if (subscribeToFb) {
                    databaseRef.child(
                        "/svf/" + clientCode + "/shotssummary/" + langId + "/games/" + gameId
                    ).on('value', handleGameShotSummaryUpdate);
                }

                return;

            };

            var subscribeToGamePenalties = function (clientCode, gameId, langId, listenerCallback) {
                if (!gameId) console.log("ERROR: svfFb::subscribeToGamePenalties saw an invalid gameId ", gameId);
                if (!langId || langId > 1) console.log("ERROR: svfFb::subscribeToGamePenalties saw an invalid langId param ", langId);
                if (!listenerCallback) console.log("ERROR: svfFb::subscribeToGamePenalties saw an invalid listenerCallback param ", listenerCallback);

                var subscribeToFb = false;

                if (gamePenaltiesCallbacksEmpty(createGameUid(clientCode, gameId, langId))) {
                    subscribeToFb = true;
                }


                addToGamePenaltiesCallbacks(clientCode, gameId, langId, listenerCallback);
                if (gamePenaltiesCallbacksEmpty(createGameUid(clientCode, gameId, langId))) {
                    console.log("ERROR: svfFb::subscribeToGamePenalties saw an inconsistency where the callbacks are empty after adding to it", gamePenaltiesCallbacks);
                }

                if (subscribeToFb) {
                    databaseRef.child(
                        "/svf/" + clientCode + "/penalties/" + langId + "/games/" + gameId
                    ).on('value', handleGamePenaltiesUpdate);
                }

                return;
            };

            var subscribeToGameScoring = function (clientCode, gameId, langId, listenerCallback) {
                if (!gameId) console.log("ERROR: svfFb::subscribeToGameScoring saw an invalid gameId ", gameId);
                if (!langId || langId > 1) console.log("ERROR: svfFb::subscribeToGameScoring saw an invalid langId param ", langId);
                if (!listenerCallback) console.log("ERROR: svfFb::subscribeToGameScoring saw an invalid listenerCallback param ", listenerCallback);

                var subscribeToFb = false;
                var gameUid = createGameUid(clientCode, gameId, langId);

                if (gameScoringCallbacksEmpty(gameUid)) {
                    subscribeToFb = true;
                }

                addToGameScoringCallbacks(clientCode, gameId, langId, listenerCallback);
                if (gameScoringCallbacksEmpty(gameUid)) {
                    console.log("ERROR: svfFb::subscribeToGameScoring saw an inconsistency where the callbacks are empty after adding to it", gameShotSummaryCallbacks);
                }

                if (subscribeToFb) {
                    let fbPath = "/svf/" + clientCode + "/goals/" + langId + "/games/" + gameId + "/GameGoals";
                    databaseRef.child(
                        fbPath
                    ).on('value', handleGameScoringUpdate);
                }

                return;
            };

            var subscribeToGameMVPs = function (clientCode, gameId, langId, listenerCallback) {
                if (!gameId) console.log("ERROR: svfFb::subscribeToGameMVPs saw an invalid gameId ", gameId);
                if (!langId || langId > 1) console.log("ERROR: svfFb::subscribeToGameMVPs saw an invalid langId param ", langId);
                if (!listenerCallback) console.log("ERROR: svfFb::subscribeToGameMVPs saw an invalid listenerCallback param ", listenerCallback);

                var subscribeToFb = false;
                var gameUid = createGameUid(clientCode, gameId, langId);

                if (gameMVPsCallbacksEmpty(gameUid)) {
                    subscribeToFb = true;
                }

                addToGameMVPsCallbacks(clientCode, gameId, langId, listenerCallback);
                if (gameMVPsCallbacksEmpty(gameUid)) {
                    console.log("ERROR: svfFb::subscribeToGameMVPs saw an inconsistency where the callbacks are empty after adding to it", gameMVPsCallbacks);
                }

                if (subscribeToFb) {
                    let fbPath = "/svf/" + clientCode + "/mvps/" + langId + "/games/" + gameId;
                    databaseRef.child(
                        fbPath
                    ).on('value', handleGameMVPsUpdate);
                }

                return;
            };

            var unsubscribeFromGameClock = function (clientCode, gameId, langId, listenerCallback) {

                removeFromGameClockCallbacks(clientCode, gameId, langId, listenerCallback)

                if (gameClockCallbacksEmpty(createGameUid(clientCode, gameId, langId))) { // Close down the firebase listeners
                    databaseRef.child("/svf/" + clientCode + "/publishedclock/" + langId + "/games/" + gameId).off('value', handlePublishedClockUpdate);
                    databaseRef.child("/svf/" + clientCode + "/runningclock/games/" + gameId).off('value', handleRunningClockUpdate);
                }
            };

            var unsubscribeFromGameGoalSummary = function (clientCode, gameId, langId, listenerCallback) {

                removeFromGameGoalSummaryCallbacks(clientCode, gameId, langId, listenerCallback);

                if (gameGoalSummaryCallbacksEmpty(createGameUid(clientCode, gameId, langId))) {
                    databaseRef.child(
                        "/svf/" + clientCode + "/goalssummary/" + langId + "/games/" + gameId
                    ).off('value', handleGameGoalSummaryUpdate);
                }

            };

            var unsubscribeFromGamePenaltySummary = function (clientCode, gameId, langId, listenerCallback) {

                removeFromGamePenaltySummaryCallbacks(clientCode, gameId, langId, listenerCallback);

                if (gamePenaltySummaryCallbacksEmpty(createGameUid(clientCode, gameId, langId))) {
                    databaseRef.child(
                        "/svf/" + clientCode + "/penaltiessummary/" + langId + "/games/" + gameId
                    ).off('value', handleGamePenaltySummaryUpdate);
                }

            };

            var unsubscribeFromGameShotSummary = function (clientCode, gameId, langId, listenerCallback) {

                removeFromGameShotSummaryCallbacks(clientCode, gameId, langId, listenerCallback);

                if (gameShotSummaryCallbacksEmpty(createGameUid(clientCode, gameId, langId))) {
                    databaseRef.child(
                        "/svf/" + clientCode + "/shotssummary/" + langId + "/games/" + gameId
                    ).off('value', handleGameShotSummaryUpdate);
                }

            };

            var unsubscribeFromGamePenalties = function (clientCode, gameId, langId, listenerCallback) {

                removeFromGamePenaltiesCallbacks(clientCode, gameId, langId, listenerCallback);

                if (gamePenaltiesCallbacksEmpty(createGameUid(clientCode, gameId, langId))) {
                    databaseRef.child(
                        "/svf/" + clientCode + "/penalties/" + langId + "/games/" + gameId
                    ).off('value', handleGamePenaltiesUpdate);
                }

            };

            var unsubscribeFromGameScoring = function (clientCode, gameId, langId, listenerCallback) {

                removeFromGameScoringCallbacks(clientCode, gameId, langId, listenerCallback);

                if (gameScoringCallbacksEmpty(createGameUid(clientCode, gameId, langId))) {
                    databaseRef.child(
                        "/svf/" + clientCode + "/goals/" + langId + "/games/" + gameId + "/GameGoals"
                    ).off('value', handleGameShotSummaryUpdate);
                }
            };

            var unsubscribeFromGameMVPs = function (clientCode, gameId, langId, listenerCallback) {

                removeFromGameMVPsCallbacks(clientCode, gameId, langId, listenerCallback);

                if (gameMVPsCallbacksEmpty(createGameUid(clientCode, gameId, langId))) {
                    databaseRef.child(
                        "/svf/" + clientCode + "/goals/" + langId + "/games/" + gameId
                    ).off('value', handleGameMVPsUpdate);
                }
            };

            return {
                authenticate: authenticate,
                subscribeToGameClock: subscribeToGameClock,
                subscribeToGamePenalties: subscribeToGamePenalties,
                subscribeToGameGoalSummary: subscribeToGameGoalSummary,
                subscribeToGamePenaltySummary: subscribeToGamePenaltySummary,
                subscribeToGameShotSummary: subscribeToGameShotSummary,
                subscribeToGameScoring: subscribeToGameScoring,
                subscribeToGameMVPs: subscribeToGameMVPs,
                unsubscribeFromGameClock: unsubscribeFromGameClock,
                unsubscribeFromGameGoalSummary: unsubscribeFromGameGoalSummary,
                unsubscribeFromGamePenaltySummary: unsubscribeFromGamePenaltySummary,
                unsubscribeFromGameShotSummary: unsubscribeFromGameShotSummary,
                unsubscribeFromGameScoring: unsubscribeFromGameScoring,
                unsubscribeFromGamePenalties: unsubscribeFromGamePenalties,
                unsubscribeFromGameMVPs: unsubscribeFromGameMVPs
            };

        }]);


// WEBPACK FOOTER //
// ./app.v2/components/shared/firebase/leaguestatFirebaseService.js